var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDublinFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35156 24C1.35156 33.825 7.65156 42.15 16.3516 45.225V2.77502C7.57656 5.85002 1.35156 14.175 1.35156 24Z",
    fill: "#83BF4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3516 24C46.3516 14.175 40.0516 5.85002 31.3516 2.77502V45.225C40.0516 42.15 46.3516 33.825 46.3516 24Z",
    fill: "#FF8736"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3516 45.225C18.6766 46.05 21.2266 46.5 23.8516 46.5C26.4766 46.5 29.0266 46.05 31.3516 45.225V2.775C28.9516 1.95 26.4766 1.5 23.8516 1.5C21.2266 1.5 18.6766 1.95 16.3516 2.775V45.225Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDublinFlag);
export default __webpack_public_path__ + "static/media/dublin-flag.ceb25bfb9ddc36429e574c7a065489f7.svg";
export { ForwardRef as ReactComponent };